import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import { Hub, NewHubFormBody, PaginatedHubsListFilters, PatchHubFormBody } from './hub.types';
import { getHubApiUrl } from './hub.paths';

const getHubList = async (params: PaginatedHubsListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<Hub>>(getHubApiUrl.list(), { params });
  return res.data.data;
};

const getHubById = async (hubId: string): Promise<Hub> => {
  const res = await http.get<ApiResponseBody<Hub>>(getHubApiUrl.hubById(hubId));
  return res.data.data;
};

const createHub = async (body: NewHubFormBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<Hub>>(getHubApiUrl.list(), body);
  return res.data.data;
};

const updateHubById = async ({ id, ...body }: PatchHubFormBody & { id: string }) => {
  const res = await http.patch<ApiResponseBody<Hub>>(getHubApiUrl.hubById(id), body);
  return res.data.data;
};

export const hubApiFetcher = {
  getHubList,
  getHubById,
  createHub,
  updateHubById,
};
